var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHybridReady)?_c('div',[_c('TkoComponent',{attrs:{"name":"section-modals"}}),_vm._v(" "),_c('ModalContainer'),_vm._v(" "),_c('NextModalFrame')],1):_vm._e()}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }